module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ticket":"Ticket","close":"Close","refresh ticket":"refresh ticket"},"de":{"ticket":"Ticket","close":"Schliessen","refresh ticket":"Ticket neu laden"}}')
  delete Component.options._Ctor
}
